<script setup lang="ts">
import { ref, computed } from 'vue';
import { chevronDownOutline, chevronForwardOutline, ticketOutline, checkmarkOutline } from 'ionicons/icons';
import { defineProps, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

// Props and Emits
const props = defineProps({
	cartItem: {
		type: Object,
		required: true,
	},
});
const emit = defineEmits(['prefillTickets', 'validationChanged']);
const { t } = useI18n();
const isOpen = ref(true); // Open by default

// Local state for name and email
const localName = ref(props.cartItem.additionalInfo?.name || t('events.guest_members.guest'));
const localEmail = ref(props.cartItem.additionalInfo?.email || '');

// Validation for the form fields
const isFormValid = computed(() => {
	return localName.value.trim() !== '' && /\S+@\S+\.\S+/.test(localEmail.value);
});

// Emit updated values to the parent component
const updateAllTickets = () => {
	emit('prefillTickets', { name: localName.value, email: localEmail.value });
	emit('validationChanged', isFormValid.value);
};
</script>

<template>
	<ion-accordion-group value="first">
		<ion-accordion class="mb-4 items-start justify-between backdrop-blur-3xl bg-[#3f3e4a] rounded-lg" value="first">
			<div class="flex w-full justify-between h-[70px] px-4 py-2 cursor-pointer" slot="header" @click="isOpen = !isOpen">
				<div class="flex items-center">
					<div class="flex items-center justify-center mr-2">
						<ion-icon :class="!isFormValid ? 'text-white' : 'text-anykrowd-ticket-check-green'" :icon="!isFormValid ? ticketOutline : checkmarkOutline" class="w-[22px] h-[22px] py-2 rounded-full"></ion-icon>
					</div>
					<div class="flex flex-col justify-center w-full">
						<span class="font-sourcesanspro-semibold text-sm text-white/50"> {{ $t('events.guest_members.details') }} </span>
						<div class="flex items-center">
							<div class="mr-1">
								<span class="font-sourcesanspro-semibolditalic text-m2"> {{ localName || $t('events.guest_members.guest') }} - {{ localEmail || $t('events.guest_members.email_not_set') }} </span>
							</div>
						</div>
					</div>
				</div>
				<div class="flex items-center font-sourcesanspro-semibold text-lg24">
					<ion-icon :icon="isOpen ? chevronDownOutline : chevronForwardOutline" class="text-white"></ion-icon>
				</div>
			</div>

			<div v-show="isOpen" class="ion-padding border-t border-t-white/10 font-sourcesanspro-regular text-base2 font-color-text-50" slot="content">
				<div class="flex flex-col mb-4">
					<div class="form-group mb-2">
						<label for="name">{{ $t('events.guest_members.name_label') }}</label>
						<input id="name" type="text" v-model="localName" :placeholder="$t('events.guest_members.name_placeholder')" class="input-field" @input="updateAllTickets" />
					</div>
					<div class="form-group">
						<label for="email">{{ $t('events.guest_members.email_label') }}</label>
						<input id="email" type="email" v-model="localEmail" :placeholder="$t('events.guest_members.email_placeholder')" class="input-field" @input="updateAllTickets" />
					</div>
				</div>
			</div>
		</ion-accordion>
	</ion-accordion-group>
</template>

<style scoped>
.input-field {
	width: 100%;
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
	margin-top: 4px;
}
</style>
